module.exports = __webpack_public_path__ + "assets/f5a7ea68136271de93291bd349a247ad.png";